export default {
	dashboard: {
		sections: {
			pulse: 'Live Overview',
			activity: 'Activity & Comments',
			workspace: 'Workspace',
			operations: 'Operations',
		},
		kpi: {
			reports: 'Reports',
			tasks: 'Tasks',
			craftsmanTasks: 'Service Requests',
			reviewDocuments: 'Document Reviews',
			personUpdates: 'Data Changes',
			meters: 'Meter Readings',
			overdueCaption: 'overdue',
			openCaption: 'open',
			soonBadge: '{count} due within 7 days',
			staleBadge: '{count} open for over 7 days',
			onTrack: 'On schedule',
			allCurrent: 'All current',
			noneOpen: 'Nothing open',
			totalTooltip: '{count} in total',
			countTooltip: '{loaded} loaded / {total} in total',
			showAll: 'Show all',
			allReports: 'All reports',
			allTasks: 'All tasks',
			allCraftsmanTasks: 'All service requests',
			filterOpen: 'Open',
			filterAll: 'All',
			filterBuilding: 'Building',
			filterType: 'Report type',
			filterStatus: 'Status',
			emptyTasks: 'No tasks available.',
			emptyCraftsmanTasks: 'No open service requests.',
			emptyReports: 'No reports available.',
			reportFallback: 'Report',
			internal: 'Internal report',
		},
		documents: {
			title: 'New Documents',
			updatedSinceLastLogin:
				'These documents have been updated since your last {lastLogin}.',
			empty: 'No new documents since the last login.',
			countTooltip: 'New documents since the last login',
		},
		buildings: {
			myObjects: 'My Buildings',
			title: 'Buildings',
			empty: 'No buildings available.',
			units: '{count} unit | {count} units',
		},
		notifications: {
			title: 'Notifications',
			empty: 'No unread notifications.',
			emptyAll: 'No notifications available.',
			markAllRead: 'Mark all as read',
			countTooltip: 'Unread / total',
			filterUnread: 'Unread',
			filterAll: 'All',
			unread: 'Unread',
			digestCount: '{count} new comment | {count} new comments',
		},
		activityFeed: {
			title: 'Activity',
			empty: 'No activity available.',
			created: 'created',
			updated: 'updated',
			deleted: 'deleted',
			countTooltip: 'Unread changes',
			erpSync: 'ERP sync',
			detail: {
				action: 'Action',
				by: 'By',
				at: 'At',
			},
		},
		models: {
			'App\\Model\\Building': 'Building',
			'App\\Model\\Persons': 'Person',
			'App\\Model\\Unit': 'Unit',
			'App\\Model\\Document': 'Document',
			'App\\Model\\Notes': 'Note',
			'App\\Model\\Tasks\\Task': 'Task',
			'App\\Model\\CraftsmanTask': 'Service Request',
			'App\\Model\\Reports\\Report': 'Report',
			'App\\Model\\Cis': 'Technical System',
			'App\\Model\\Cis\\Cis': 'Technical System',
			'App\\Model\\Roles': 'Role',
			'App\\Model\\Team': 'Team',
			'App\\Model\\Invoices': 'Invoice',
			'App\\Model\\Accounts\\Accounts': 'Account',
			'App\\Model\\Accounts\\Journals': 'Journal Entry',
			'App\\Model\\ReviewDocuments\\ReviewDocuments': 'Document Review',
		},
		comments: {
			title: 'Comments',
			empty: 'No comments available.',
			markAllRead: 'Mark all as read',
			filterAll: 'All',
			filterUnread: 'Unread',
			emptyUnread: 'No unread comments.',
			context: {
				report: 'Report',
				account: 'Account',
				journal: 'Journal entry',
				reviewDocument: 'Document review',
				email: 'Email',
			},
		},
		commentDialog: {
			title: 'Comment',
			journalDetails: 'Journal entry details',
			bookingText: 'Booking text',
			bookingDate: 'Booking date',
			debit: 'Debit',
			credit: 'Credit',
			primanota: 'Primanota',
			accountRef: 'Account ref.',
			accountDetails: 'Account details',
			accountNo: 'Account no.',
			designation: 'Name',
			buildingRef: 'Building ref.',
			edited: 'edited {time}',
			edit: 'Edit',
			delete: 'Delete',
			save: 'Save',
			cancel: 'Cancel',
			report: 'Report',
			internal: 'Internal',
			readBy: 'Read by {count} person | Read by {count} people',
			replies: '{count} reply | {count} replies',
			reply: 'Reply',
			replyPlaceholder: 'Write a reply …',
			contextReviewDocument: 'Document review: {name}',
			contextAccount: 'Account: {name}',
			contextJournal: 'Journal entry: {name}',
			contextReport: 'Report #{id}',
			contextEmail: 'Email',
		},
		syncs: {
			title: 'Synchronization',
			empty: 'No synchronizations available.',
			lastSync: 'Last synchronization',
			statusDone: 'Completed',
			statusRunning: 'Running …',
			changes: '{count} change | {count} changes',
			noDetails: 'No details available',
			showDetails: 'Show details',
			open: 'Open synchronization',
			allLoaded: 'All {count} entries loaded',
			runningFor: 'for {duration}',
			duration: {
				seconds: '{s} s',
				minutes: '{m} min {s} s',
				hours: '{h} h {m} min',
				days: '{d} d {h} h',
			},
			models: {
				'App\\Model\\Building': 'Buildings',
				'App\\Model\\Persons': 'Persons',
				'App\\Model\\Unit': 'Units',
				'App\\Model\\Document': 'Documents',
				'App\\Model\\Notes': 'Notes',
				'App\\Model\\Tasks\\Task': 'Tasks',
				'App\\Model\\CraftsmanTask': 'Service requests',
				'App\\Model\\Reports\\Report': 'Reports',
				'App\\Model\\Cis': 'Technical systems',
				'App\\Model\\Accounts\\Accounts': 'Accounts',
				'App\\Model\\Accounts\\Journals': 'Journal entries',
				'App\\Model\\Invoices': 'Invoices',
				'App\\Model\\MeterLevelDetection\\MeterLevel': 'Meter readings',
			},
		},
		tasks: {
			title: 'Tasks',
			empty: 'No open tasks.',
			countTooltip: 'Due tasks',
		},
		notes: {
			title: 'Notes',
			empty: 'No notes available.',
			create: 'Create note',
			filterActive: 'Active',
			filterAll: 'All',
			filterBuilding: 'Building',
			filterType: 'Type',
			layoutList: 'List view',
			layoutGrid: 'Grid view',
			priorityHigh: 'High priority',
			priorityMedium: 'Medium priority',
			comments: '{count} comment | {count} comments',
			buildingsCount: '{count} property | {count} properties',
			rolesCount: '{count} role | {count} roles',
			documentsCount: '{count} document | {count} documents',
			document: 'Document',
			readMore: 'Read more',
		},
		cis: {
			title: 'Technical Systems',
			empty: 'No technical systems available.',
			system: 'Technical system',
			statusDone: 'Done',
			statusOpen: 'Open',
		},
		reviewDocuments: {
			title: 'Document Review',
			empty: 'No document reviews available.',
			filterOpen: 'Open',
			filterDone: 'Completed',
			filterAll: 'All',
			countTooltip: 'Open document reviews',
			statusDone: 'Completed',
			statusOpen: 'Open',
			mine: 'Your open document reviews',
			progress: 'Progress: {percent}%',
			reviewersOpen: '{open}/{total} reviewers open',
			unreadComments: 'Unread comments: {count}',
			lastReview: 'Last review',
			reviewer: {
				finished: 'Completed',
				rejected: 'Rejected',
				pending: 'Pending',
				unknown: 'Unknown',
			},
		},
		craftsmanTasks: {
			title: 'Service Requests',
			empty: 'No open service requests.',
			countTooltip: 'Open service requests',
			deadline: 'Deadline',
			noDeadline: 'No deadline',
			plannedFor: 'planned {date}',
		},
		todo: {
			title: 'To do',
			empty: 'Nothing due.',
			countTooltip:
				'Overdue or due within the next 7 days, {overdue} of them overdue',
			shownOfTotal:
				'Showing {shown} of {total}. You can find the rest in the respective sections.',
		},
		search: {
			placeholder: 'Search properties, persons, reports…',
			noResults: 'No results for "{query}".',
			moreResults: 'More results',
			searching: 'Searching …',
			indexing: 'Indexing…',
			shortcut: 'Press / to focus the search',
			fallback: {
				notification: 'Notification',
				comment: 'Comment',
				note: 'Note',
				building: 'Property',
				document: 'Document',
				sync: 'Sync #{id}',
			},
		},
		presets: {
			standard: {
				name: 'Standard',
				desc: 'The previous layout with four sections.',
			},
			daily: {
				name: 'Daily business',
				desc: 'Inbox first: notifications, comments, properties.',
			},
			billing: {
				name: 'Accounting',
				desc: 'Review documents, documents and sync in focus.',
			},
			overview: {
				name: 'Overview',
				desc: 'Everything at a glance, compact in three columns.',
			},
			minimal: {
				name: 'Basic',
				desc: 'What needs action first: to do, notes, comments, document reviews, notifications, documents, properties.',
			},
		},
		edit: {
			title: 'Edit layout',
			start: 'Edit layout',
			choosePreset: 'Choose template…',
			ownLayout: 'Custom layout',
			ownDesc: '{n} widgets · custom layout',
			selected: 'Selected',
			deselect: 'Clear selection (Esc)',
			headerText: 'Text',
			width: 'Width',
			widthOf: '{w} of 12 columns',
			full: 'Full',
			rows: 'Rows in list',
			rowsLess: 'One row less',
			rowsMore: 'One row more',
			density: 'Density',
			density_normal: 'Normal',
			density_compact: 'Compact',
			position: 'Position',
			left: 'Left (←)',
			up: 'Up (↑)',
			down: 'Down (↓)',
			right: 'Right (→)',
			moveUp: 'Move up',
			moveDown: 'Move down',
			remove: 'Remove from dashboard',
			tabBlocks: 'Blocks',
			tabKpi: 'Key figures',
			tabPresets: 'Templates',
			placed: 'On the dashboard · {n}',
			available: 'Available',
			allPlaced: 'All widgets are placed.',
			add: 'Add',
			header: 'Heading',
			headerItem: 'Heading · {label}',
			newSection: 'New section',
			greeting: 'Greeting',
			greetingShow: 'Show greeting text',
			kpiHint: 'Order and visibility of the key figures above.',
			hidden: 'Hidden',
			presetHint:
				'A template replaces the current layout. Press Ctrl+Z to undo.',
			active: 'Active',
			deletePreset: 'Delete layout',
			saveTitle: 'Save current layout',
			savePlaceholder: 'Name, e.g. Monday meeting',
			save: 'Save',
			refreshTitle: 'Automatic refresh',
			dragWidth: 'Drag width',
			dragRows: 'Drag rows',
			dragSize: 'Drag size',
			sizeTag: '{w}/12',
			sizeTagRows: '{w}/12 · {rows} rows',
			undo: 'Undo (Ctrl+Z)',
			redo: 'Redo (Ctrl+⇧+Z)',
			cancel: 'Cancel',
			done: 'Done',
			hintIdle: 'Click a widget or drag it by its header',
			hintSelected: '←→↑↓ move · ⇧ size · Del remove',
			hintMobile: 'Arrows change the order',
			saveFailed:
				'The layout could not be saved. Please try again or cancel editing.',
			refreshMinutes: '{n} min',
			deletePresetConfirm: 'Delete the layout "{name}"?',
		},
		settings: {
			customize: 'Customize',
			resetMenu: 'Reset to Basic',
			reset: 'Reset',
			resetConfirm:
				'Reset the dashboard to the "Basic" template? Your saved custom layouts are kept.',
			resetTitle: 'Restore Basic layout',
			loadFailed: 'Your dashboard layout could not be loaded.',
			retry: 'Try again',
		},
		freshness: {
			justUpdated: 'Just updated',
			minutesAgo: 'Updated {min} min. ago',
			hoursAgo: 'Updated {hours} hr. ago',
			updating: 'Updating...',
			refresh: 'Refresh data',
		},
		common: {
			due: {
				today: 'today',
				tomorrow: 'tomorrow',
				yesterday: 'yesterday',
				inDays: 'in {n} days',
				daysAgo: '{n} days ago',
			},
			new: 'New',
			showAll: 'Show all',
			fullscreen: 'Fullscreen',
			exitFullscreen: 'Exit fullscreen',
			expand: 'Expand widget',
			collapse: 'Collapse widget',
			hide: 'Hide widget',
			loadingMore: 'Loading more …',
			endOfList: 'End of list',
			loadError: 'The data could not be loaded.',
			retry: 'Reload',
			close: 'Close',
			unknown: 'Unknown',
			unavailable: 'Object no longer available',
		},
		tour: {
			open: 'Start dashboard tour',
			shared: {
				search: {
					title: 'Search',
					text: 'Searches the entries of your widgets and, below them, further properties, persons and reports. Press <kbd>/</kbd> to jump straight in; a result opens the entry.',
					// Below 960 px (narrow and medium): without keyboard shortcut
					text_compact:
						'Searches the entries of your widgets and, below them, further properties, persons and reports. Type a term; a result opens the entry.',
				},
				greeting: {
					title: 'Greeting',
					text: 'This is the greeting text of the portal. While editing the layout you can hide it for yourself.',
					text_compact:
						'This is the greeting text of the portal. You can hide it while editing the layout on a wider screen.',
				},
				widget: {
					title: 'Widgets',
					text: 'Each widget shows part of your data; the number in its header counts open or new entries. On the right of the header you can enlarge a widget to full width or hide it. Hidden widgets can be brought back while editing the layout.',
					text_compact:
						'Each widget shows part of your data; the number in its header counts open or new entries. On the right of the header you can enlarge a widget or hide it. Hidden widgets can be brought back while editing the layout on a wider screen.',
				},
				section: {
					title: 'Sections',
					text: 'Headings structure the dashboard. Clicking a heading collapses or expands the section below it; this is remembered for you.',
				},
				todo: {
					title: 'To do',
					text: 'Collects everything from the areas available to you that is overdue or due within the next seven days.',
				},
				notifications: {
					title: 'Notifications',
					text: 'New documents, notes, comments and status changes appear here. Unread ones are highlighted; the button in the header marks all as read.',
				},
				comments: {
					title: 'Comments',
					text: 'The latest comments, for example on reports or document reviews. A click opens the comment in its context, where you can reply directly.',
				},
				refresh: {
					title: 'Freshness',
					text: 'Next to it you can see how current the displayed data is. This button reloads it right away.',
					text_compact: 'This button reloads the displayed data right away.',
				},
				settings: {
					title: 'Customize',
					text: 'Customize the dashboard here: edit the layout, choose a template or reset to the basic layout. You can also restart this tour here at any time.',
					text_compact:
						'Use this icon to customize the dashboard: change the order of the widgets or reset to the basic layout. You can also restart this tour here at any time.',
				},
				edit_grid: {
					title: 'Edit layout',
					text: 'In edit mode you arrange the widgets freely: drag them by the header, change width and rows at the edges. A selected widget can also be moved with the arrow keys. For this tour the mode is only opened; nothing is changed.',
					title_compact: 'Change order',
					text_compact:
						'In edit mode you change the order: the arrows in the header of a widget or heading move it up or down. This order only applies to narrow screens; the layout on wide screens stays as it is. For this tour the mode is only opened; nothing is changed.',
				},
				edit_more_on_wide: {
					title: 'More on wider screens',
					text: 'On a wider screen, for example on a computer, you can also add widgets and headings, bring back hidden widgets, arrange key figures, choose templates and change the size of widgets while editing.',
				},
				edit_blocks: {
					title: 'Building blocks',
					text: 'Here you see what is on the dashboard and what is still available. You add widgets and headings and show or hide the greeting. Which widgets are available depends on your permissions.',
				},
				edit_kpi: {
					title: 'Arrange key figures',
					text: 'Choose which key figures appear at the top and in which order.',
				},
				edit_presets: {
					title: 'Templates',
					text: 'A template replaces the current layout with one click; Ctrl+Z undoes it. Below, you save your own layout under a name and set how often the dashboard refreshes automatically.',
				},
				edit_dock: {
					title: 'Save or discard',
					text: 'This bar stays visible while editing: undo and redo, “Cancel” discards all changes, “Done” saves the layout. The tour closes edit mode again right away without saving.',
				},
				outro: {
					title: 'All in view',
					text: 'You can find this tour at any time under <strong>Customize → Start dashboard tour</strong>.',
					text_compact:
						'You can restart this tour at any time via this button and <strong>Start dashboard tour</strong>.',
				},
			},
			team: {
				welcome: {
					title: 'Your dashboard',
					text: 'The dashboard brings together what is on today: key figures, due items, new comments and the sync status. In a few steps we show you how to read it and adapt it to the way you work. You can end the tour at any time via the ✕ or <kbd>Esc</kbd>.',
				},
				kpi: {
					title: 'Key figures',
					text: 'The bar shows open and overdue items such as reports, follow-ups, craftsman tasks or data changes. The large number is what is urgent; the badge announces what is due soon. Clicking a tile expands its list.',
				},
				activity: {
					title: 'Activities',
					text: 'Shows what has recently changed on properties, persons, documents and processes, including changes from the ERP sync. A click opens the details of the change.',
				},
				syncs: {
					title: 'Synchronization',
					text: 'The latest syncs with your ERP system: when they ran, whether they finished and how many changes they brought.',
				},
				review_documents: {
					title: 'Document review',
					text: 'Document reviews with progress, open reviewers and deadline. A click opens the review.',
				},
			},
			user: {
				welcome: {
					title: 'Your dashboard',
					text: 'The dashboard shows at a glance what is new and what is pending for you. In a few steps we show you how to read it and arrange it the way you like. You can end the tour at any time via the ✕ or <kbd>Esc</kbd>.',
				},
				kpi: {
					title: 'Key figures',
					text: 'The bar shows how many of your items are open, for example reports. Clicking a tile expands its list.',
				},
				notes: {
					title: 'Notes',
					text: 'Current announcements from your property management about your properties. Use the filters in the widget to choose a property or type of note.',
				},
				documents: {
					title: 'New documents',
					text: 'Documents that have been added or updated since your last login.',
				},
				review_documents: {
					title: 'Document review',
					text: 'The document reviews you take part in, with progress and deadline. A click opens the review.',
				},
			},
		},
	},
}
